// Khung project: tab Work (Tổng quan · Dữ liệu) và Build (Bản thiết kế · Cấu trúc · Lịch sử) + Thành viên — theo IA.md.
// Mọi tab hiện với MỌI vai trò (quyết định người dùng 2026-10-22, SAA-2026-012 — thay dòng « ẩn hẳn » cũ): người dùng thấy
// app có gì; nhãn vai trò nói trước mình làm được gì, server chặn và câu từ chối nói cần vai trò nào.
import { useTranslation } from "react-i18next";
import { NavLink, Outlet, useParams } from "react-router";
import { useCurrentWorkspace } from "../../app/session.ts";
import { useProject } from "./project-hooks.ts";
import { ProjectRoleBadge } from "./role-hint.tsx";

export function ProjectLayout() {
  const { t } = useTranslation();
  const cur = useCurrentWorkspace()!;
  const { projectId = "" } = useParams();
  const project = useProject(projectId);
  const base = `/w/${cur.workspaceId}/projects/${projectId}`;
  const tabs = [
    { to: base, label: t("project.tabs.overview"), end: true },
    { to: `${base}/surfaces`, label: t("surfaces.list.title"), end: false },
    { to: `${base}/data`, label: t("project.tabs.data"), end: false },
    { to: `${base}/build`, label: t("project.tabs.build"), end: true },
    { to: `${base}/build/structure`, label: t("project.tabs.structure"), end: true },
    { to: `${base}/build/history`, label: t("project.tabs.history"), end: true },
    { to: `${base}/members`, label: t("project.tabs.members"), end: true },
  ];
  return (
    <div className="flex flex-col gap-4">
      {project.data ? (
        <div className="flex flex-col gap-1">
          <p className="text-sm text-(--saa-fg-muted)">
            {project.data.data.name} · <span className="font-mono">{project.data.data.key}</span>
          </p>
          <ProjectRoleBadge role={project.data.data.myRole} />
        </div>
      ) : null}
      <nav aria-label={t("project.tabs.label")} className="flex flex-wrap gap-1 border-b border-(--saa-border)">
        {tabs.map((x) => (
          <NavLink key={x.to} to={x.to} end={x.end} className={({ isActive }) => `-mb-px border-b-2 px-3 py-2 text-sm ${isActive ? "border-(--saa-primary) font-medium" : "border-transparent text-(--saa-fg-muted) hover:text-(--saa-fg)"}`}>
            {x.label}
          </NavLink>
        ))}
      </nav>
      <Outlet />
    </div>
  );
}
